import type { PlatformPermission } from './definitions';

export type PlatformAccessMap = Partial<Record<PlatformPermission, boolean>>;

/**
 * 后端返回的 `资源:操作` 列表转成 access 映射；管理隐含查看。
 * 直接按返回值生成、不依赖前端的资源清单：后端新增资源而前端清单漏同步时，权限也不会被丢掉。
 */
export function buildPlatformAccessMap(
  permissions: string[] = [],
): PlatformAccessMap {
  const map: Record<string, boolean> = {};
  for (const permission of permissions) {
    const [resource, action] = permission.split(':');
    if (!resource || (action !== 'read' && action !== 'manage')) continue;
    map[permission] = true;
    if (action === 'manage') map[`${resource}:read`] = true;
  }
  return map as PlatformAccessMap;
}
